module.exports = __webpack_public_path__ + "img/pic7.7f6dae4f.png";